import { BackgroundProps } from './types';
import { StyledBackground } from './style';
import { useIsDesktop, useIsLandscape } from '../../utils';

function Background({
    backgroundImageMobile,
    backgroundImageDesktop,
    backgroundPosition = 'center top',
    backgroundSize = 'cover',
    backgroundColor = '',
    width = '100vw',
    height = '100vh',
    minHeight = 'unset',
    position = 'static',
    children
}: BackgroundProps) {
    const isLandscape = useIsLandscape();
    const isDesktop = useIsDesktop();

    return (
        <StyledBackground
            backgroundImage={
                isDesktop || isLandscape
                    ? backgroundImageDesktop
                    : backgroundImageMobile
            }
            backgroundColor={backgroundColor}
            backgroundPosition={backgroundPosition}
            backgroundSize={backgroundSize}
            width={width}
            height={height}
            minHeight={minHeight}
            position={position}
        >
            {children}
        </StyledBackground>
    );
}

export default Background;
